import React, { useEffect, useState } from "react";
import { Button } from "../../../../../stories/Button/Button";
import classes from "./cancelBookingDone.module.css";
import Colors from "../../../../../stories/assets/Colors";
import Fonts from "../../../../../stories/assets/Fonts";
import ModalSkeleton from "../../../../ModalSkeleton/ModalSkeleton";
import ModalClasses from "../../../../ModalSkeleton/ModalSkeleton.module.css";
import { isMobileViewHook } from "../../../../../CustomHooks/isMobileViewHook";

function CancelBookingDone({ show, setShow }) {
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    isMobileViewHook(setIsMobile);
  }, []);

  return (
    <>
      <style>{`
          @media screen and (max-width: 580px) {
        .modal .modal-dialog {
          width: 80% !important;
          margin: 0px 10%;
        }
        .${ModalClasses.iconBox}{
            right:12px;
        }
  `}</style>
      <ModalSkeleton
        show={show}
        setShow={setShow}
        hideHeaderBorder
        borderRadius={"20px"}
        width={"509px"}
        showCloseIcon
      >
        <div className={classes.modalContent}>
          <h4
            style={{
              ...Fonts.h4,
              fontSize: "26px",
              color: Colors.neutralShadesOfNero,
            }}
          >
            Cancel booking
          </h4>

          <p
            style={{ ...Fonts.p1, color: Colors.neutralShadesOfDimGray }}
            className={classes.mt8}
          >
            Your booking was successfully cancelled.
          </p>
          <div className={classes.mt32}>
            <Button
              primary={false}
              size={"Large"}
              customStyle={{ width: isMobile ? "100%" : "max-content" }}
            >
              Book another lesson
            </Button>
          </div>
        </div>
      </ModalSkeleton>
    </>
  );
}

export default CancelBookingDone;
